import * as React from "react";
import { Chip } from "@mui/material";

type Status = "Posted" | "Pending" | "Not Posted" | "Error" | string;

const STYLE: Record<string, { border: string; text: string; bg: string }> = {
  Posted:     { border: "#6CCB8E", text: "#3AA35E", bg: "rgba(108,203,142,.10)" },
  Pending:    { border: "#FFB561", text: "#E6891E", bg: "rgba(255,181,97,.10)" },
  "Not Posted": { border: "#D1D5DB", text: "#6B7280", bg: "rgba(209,213,219,.20)" },
  Error:      { border: "#F2A5A5", text: "#D64545", bg: "rgba(242,165,165,.14)" },
};

export const StatusChip: React.FC<{ status: Status; clickable?: boolean }> = ({ status, clickable }) => {
  const s = STYLE[status] ?? STYLE["Not Posted"];
  const clickableStyles = clickable
    ? {
        cursor: "pointer",
        "&:hover": {
          borderColor: "#57B876",
          backgroundColor: "rgba(108,203,142,.16)", // slightly stronger green, same family
        },
      }
    : {};

  return (
    <Chip
      label={status}
      size="small"
      variant="outlined"
      sx={{
        borderColor: s.border,
        color: s.text,
        backgroundColor: s.bg,
        fontWeight: 600,
        borderWidth: 1,
        borderRadius: "9999px",
        px: 1.25,
        height: 24,
        "& .MuiChip-label": { px: 0.5, lineHeight: 1 },
        ...clickableStyles,
      }}
    />
  );
};
